<template>
  <section class="subscription-box-order-return-list">

    <el-breadcrumb>
      <el-breadcrumb-item>Operações</el-breadcrumb-item>
      <el-breadcrumb-item><b>Retornos/Devoluções</b></el-breadcrumb-item>
    </el-breadcrumb>

    <snowflake-search-list context="subscription-box-order-return" :service="subscriptionBoxOrderReturnService"
      :operations="false" :default-table-filters="defaultTableFilters" action-title="Registrar Retorno"
      :action-link-to="registerReturnLink" :page-size="20">

      <template slot="emptyText">Nada encontrado.</template>

      <template slot="tableRows">

        <!-- ID -->
        <el-table-column prop="id" label="ID" width="70" sortable></el-table-column>

        <!-- Order -->
        <el-table-column prop="boxOrderId" label="Pedido" width="90" sortable></el-table-column>

        <!-- Customer -->
        <el-table-column prop="customerName" label="Cliente" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div>{{ scope.row.customerName }}</div>
            <small class="muted">Edição {{ scope.row.edition }}</small>
          </template>
        </el-table-column>

        <!-- Type -->
        <el-table-column column-key="type" prop="type" label="Tipo" width="130" :filters="typeFilters">
          <template slot-scope="scope">{{ describeType(scope.row.type) }}</template>
        </el-table-column>

        <!-- Status -->
        <el-table-column column-key="status" prop="status" label="Status" width="180" :filters="statusFilters">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row)" size="small">{{ describeStatus(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>

        <!-- NFes -->
        <el-table-column label="NF Devolução" width="120">
          <template slot-scope="scope">{{ scope.row.returnNFe || '—' }}</template>
        </el-table-column>

        <el-table-column label="NF Perda" width="110">
          <template slot-scope="scope">{{ scope.row.lossNFe || '—' }}</template>
        </el-table-column>

        <!-- What is blocking it -->
        <el-table-column label="Pendência" min-width="220">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.lastFailureReason" effect="dark" placement="top"
              :content="scope.row.lastFailureReason">
              <span class="failure">
                <i class="el-icon-warning-outline"></i> {{ scope.row.lastFailureReason }}
              </span>
            </el-tooltip>
            <span v-else-if="scope.row.pending" class="muted">Aguardando conclusão</span>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column>

        <!-- Created -->
        <el-table-column prop="createdAt" label="Registrada em" width="150" sortable>
          <template slot-scope="scope">{{ formatDate(scope.row.createdAt) }}</template>
        </el-table-column>

      </template>
    </snowflake-search-list>

  </section>
</template>

<script>
import moment from 'moment';

import SnowflakeSearchList from '@/components/list/SearchList.vue';
import SubscriptionBoxOrderReturnService from '@/services/fulfillment/SubscriptionBoxOrderReturnService';

export default {
  name: 'subscription-box-order-return-list',
  components: {
    SnowflakeSearchList,
  },
  data() {
    return {
      subscriptionBoxOrderReturnService: SubscriptionBoxOrderReturnService,
      // The list exists to work through what is stuck, so it opens on the unfinished returns.
      defaultTableFilters: {
        status: ['NEW', 'RETURN_NFE_CREATED'],
      },
    };
  },
  computed: {
    statusFilters() {
      return Object
        .entries(SubscriptionBoxOrderReturnService.statusTranslation)
        .map(([value, text]) => ({ text, value }));
    },
    typeFilters() {
      return Object
        .entries(SubscriptionBoxOrderReturnService.typeTranslation)
        .map(([value, text]) => ({ text, value }));
    },
  },
  methods: {
    describeStatus(status) {
      return SubscriptionBoxOrderReturnService.describeStatus(status);
    },
    describeType(type) {
      return SubscriptionBoxOrderReturnService.describeType(type);
    },
    statusTagType(row) {
      if (!row.pending) return 'success';
      return row.lastFailureReason ? 'danger' : 'warning';
    },
    formatDate(iso) {
      if (!iso) return '—';
      return moment(iso).format('DD/MM/YYYY HH:mm');
    },
    registerReturnLink() {
      return { name: 'register-return' };
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-box-order-return-list {

  .el-breadcrumb {
    margin-bottom: 16px;
  }

  .muted {
    color: #909399;
  }

  .failure {
    color: #f56c6c;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
